import { create } from 'zustand'

import apiClient from '@/api/axios'

import { API_ENDPOINTS } from '../api/endpoints'

interface AppSettingsState {
  // app readiness
  isAppReady: boolean
  setAppReady: (ready: boolean) => void

  // app settings data
  settings: Record<string, any> | null
  loading: boolean
  error: Error | null

  // fetch app settings action
  fetchSettings: () => Promise<void>
}

export const useAppStore = create<AppSettingsState>((set) => ({
  // initial state
  isAppReady: false,
  settings: null,
  loading: false,
  error: null,

  // setters
  setAppReady: (ready) => set({ isAppReady: ready }),

  // async action
  fetchSettings: async () => {
    set({ loading: true, error: null })
    try {
      const res = await apiClient.get(API_ENDPOINTS.appSettings.base)
      set({ settings: res.data, loading: false })
    } catch (error) {
      set({ error: error as Error, loading: false })
    }
  },
}))
